import { Button, Group, Stack, Text, ThemeIcon } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconX } from "@tabler/icons-react";
import React from "react";

const LinkedinError = () => {
  return (
    <Stack align="center">
      <Group wrap="nowrap">
        <ThemeIcon variant="light" color="red" size={"lg"}>
          <IconX size={18} />
        </ThemeIcon>
        <Text size="lg" c={"red"}>
          Une erreur est survenue lors de la vérification de votre compte.
        </Text>
      </Group>

      <Text size="lg">
        Veuillez le reconnecter avec les bons identifiants et mot de passe.
      </Text>

      <Group mt={"md"} justify="center">
        <Button
          onClick={() => {
            modals.close("account-invalid");
            document.getElementById("linkedin-password").focus();
          }}
          size="md"
        >
          Corriger le compte
        </Button>
      </Group>
    </Stack>
  );
};

export default LinkedinError;
